import { normalizeString } from './format';
import { integrationConfig } from './integration';
import electron from './electron';

const { SALESFORCE, BULLHORN, ZOHO_ID } = integrationConfig;

export function verifyIfLetterExist(letter) {
  const verify = 'abcdefghijklmnopqrstuvxzwy';
  const letterNormalize = normalizeString(letter).toLowerCase();

  if (verify.includes(letterNormalize)) {
    letter = letterNormalize.toUpperCase();
  } else {
    letter = '#';
  }

  return letter;
}

export function normalizeContactObjects(obj, letter = null) {
  const normalized = {
    id: obj.id,
    name: `${`${obj.first_name} ${obj.last_name}`}`,
    letter: letter || '',
    landline: obj.landline,
    email: obj.email,
    mobile: obj.mobile,
    address1: obj.address1,
    address2: obj.address2,
    address3: obj.address3,
    address4: obj.address4,
    birthday: obj.birthday,
    last_updated: obj.last_updated,
    deleted: obj.deleted,
  };
  return normalized;
}

/**
 * Extract information from contact externalId string
 * @param {string | null | undefined} externalId - Represent the externalId or contact intergrated Id
 */
export function extractDetailsFromExternalId(externalId) {
  if (typeof externalId !== 'string') return {};

  if (externalId.includes('/')) {
    return {
      bullhornType: externalId.split('/')[0],
      bullhornId: externalId.split('/')[1],
    };
  }

  return {};
}

/**
 * Define external contact URL to access integrations page.
 * @param {Object} accountIntegrations - Available integrations for account
 * @param {number} integrationId - Represent the integraionId (exemple: 30 pipedrive / 34 hubspot)
 * @param {string} externalId - Represent external contactId
 */
export function getContactExternalURL(
  accountIntegrations,
  integrationId,
  externalId
) {
  if (!accountIntegrations || !integrationId || !externalId) return null;

  const integration = accountIntegrations.filter(
    e => Number(e.id) === Number(integrationId)
  );

  const baseContactURL = integration && integration[0]?.actionUrl?.contact_url;

  if (baseContactURL && externalId) {
    if (Number(integrationId) === SALESFORCE) {
      return baseContactURL.replace('[external_id]', externalId);
    }

    if (Number(integrationId) === BULLHORN) {
      const { bullhornType, bullhornId } = extractDetailsFromExternalId(
        externalId
      );

      return baseContactURL
        .replace('[type]', bullhornType)
        .replace('[external_id]', bullhornId);
    }

    if (
      Number(integrationId) === ZOHO_ID &&
      baseContactURL?.includes('[ContactType]&id=[ContactId]')
    ) {
      const zohoBaseUrl = baseContactURL.split(
        '[ContactType]&id=[ContactId]'
      )[0];
      const zohoUrlParams = baseContactURL.split(
        '[ContactType]&id=[ContactId]'
      )[1];

      return `${zohoBaseUrl}${zohoUrlParams.split('/')[0]}&id=${
        zohoUrlParams.split('/')[1]
      }`;
    }

    return baseContactURL + externalId;
  }

  return baseContactURL || null;
}

/**
 * Open a external url on web browser page.
 * @param {string} url - a valid string url as param
 */
export function openExternalURL(url) {
  if (!url) return;

  if (window.isElectron) {
    electron.openExternalUrl({
      url,
    });
  } else {
    window.open(url, '_blank');
  }
}
